import JSEncrypt from '@/utils/jsencrypt'; 
/**
 * token操作封装
 */
import { TOKEN_STORE_NAME, USER_LOGIN_TYPE } from '@/config/setting';

const PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDeFa1+8eLkYlNmiRyUYuSV2EEEWklEkWEhDKnKgs9RS/LVan5zBjja6XRkWtMo6vm7O57UN50zttDlXSXgKKE7ISKK5HPl+s6Z2ieRwjm8UfW3sGwDet2w63/f052zXlQmYG7a0MCPU8LBgqo9b3fD2Rh5DeB3cornfjektIXn8wIDAQAB'

/**
 * 获取缓存的token
 * @returns {string}
 */
export function getToken() {
  const token = localStorage.getItem(TOKEN_STORE_NAME);
  if (!token) {
    return sessionStorage.getItem(TOKEN_STORE_NAME);
  }
  return token;
}

/**
 * 缓存token
 * @param token token
 * @param remember 是否永久存储
 */
export function setToken(token, remember) {
  removeToken();
  if (token) {
    if (remember) {
      localStorage.setItem(TOKEN_STORE_NAME, token);
    } else {
      sessionStorage.setItem(TOKEN_STORE_NAME, token);
    }
  }
}

/**
 * 移除缓存的token
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_STORE_NAME);
  sessionStorage.removeItem(TOKEN_STORE_NAME);
}

/**
 * RSA加密
 */
export function rsaEncrypt(data) {
  try {
    // 对字符串进行Base64编码
    var encoded = btoa(unescape(encodeURIComponent(data)));
    return encoded;
  } catch (e) {
    console.error('Error during Base64 encoding:', e);
    return null;
  }
}

/**
 * 获取登录类型
 */
export function getLoginType() {
  return localStorage.getItem(USER_LOGIN_TYPE);
}

/**
 * 设置登录类型
 */
export function setLoginType(loginType) {
  localStorage.setItem(USER_LOGIN_TYPE, loginType);
}